import * as React from 'react';
import { DisplayNumberProps } from 'ui/display-number/display-number';
import styles from './display-numeric-header.scss';

export const DisplayNumericHeader: React.FunctionComponent<DisplayNumberProps> = (props: DisplayNumberProps) => {  
  
  const { className, componentId, label, valueItem, formatNumber, maxDecimals, useThousand } = props;  
  const labelText = (label && label.visible !== false) && label.text;    
  const intlOptions = { maximumFractionDigits: maxDecimals, useGrouping: useThousand as boolean };
  const numericText = !!valueItem && !!valueItem.value && formatNumber(valueItem.value, intlOptions);     
  
  return (
    !!valueItem && !!valueItem.value && !isNaN(Number(valueItem.value)) &&  
      <h3 className={`${styles.numericHeader} ${className}`} id={componentId}>
        {label && <span className={`${styles.label}`}>{labelText}</span>}
        <span className={`${styles.numericText}`}>{numericText}</span>          
      </h3>
  );
};
